import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';

export const PartnersOrdersView = angular
  .module('acme.view.application.partners.orders', [
    uiRouter,
    'ui.bootstrap',
    'acme.view.application.partners.orders.controllers',
    'acme.view.application.partners.orders.list',
    'acme.view.application.partners.orders.detail',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.partners.orders',
      url: '/orders',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'PartnersOrdersController',
          templateUrl: 'views/application/views/partners/orders/orders.tpl.html',
        },
      },
      data: {
        pageTitle: 'Organization Orders',
        permissions: ['ACCT_ORDERS_VIEW'],
      },
    });
  }).name;
